import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, RouteState } from '../reducers';
import { fromPl } from '../reducers';
import { PlState } from '../pl.types';
import * as fromCube from 'app/main/cube/cube.reducer';
import * as fromAnalytics from 'app/main/analytics/reducers';
import { AnalyticsState } from 'app/main/analytics/analytics.types';
import { selectFlatAna2Groups } from 'app/main/analytics/selectors/analytics.selectors';
import { selectCubeAnalytics } from 'app/main/cube/cube.selectors';
import * as _ from 'lodash';

export const getRouteState = createFeatureSelector<State, RouteState>('pl');

export const selectCubeState = createFeatureSelector<fromCube.CubeState>(
  'cube'
);
export const selectCubeAll = createSelector(
  selectCubeState,
  fromCube.selectAll
);

export const AnaRouteState = createFeatureSelector<
  fromAnalytics.State,
  fromAnalytics.RouteState
>('analytics');

export const selectAnalyticsState = createSelector(
  AnaRouteState,
  ({ api }): AnalyticsState => api
);

export const selectAnalyticsAll = createSelector(
  selectAnalyticsState,
  fromAnalytics.fromAnalytics.selectAll
);

export const selectAnalyticsEntities = createSelector(
  selectAnalyticsState,
  fromAnalytics.fromAnalytics.selectEntities
);

export const selectPlState = createSelector(
  getRouteState,
  ({ api }): PlState => api
);

export const selectPl = createSelector(selectPlState, fromPl.selectAll);

export const selectAnaByTimeline = createSelector( // Ana2 and Ana3
  selectCubeAnalytics,
  (cube) => {
    const ana3ListByAna2: any = _.groupBy(
      cube,
      'ana2Name'
    );
  
    Object.keys(ana3ListByAna2).forEach((ana2Name) => {
      ana3ListByAna2[ana2Name] = Object.keys(_.groupBy(ana3ListByAna2[ana2Name], 'ana3Name'));
    });

    const Ana2NameByTimeline = {};
    const Ana3NameByTimeline = {};
    const cubeByTimeline = _.groupBy(cube, 'timeline');

    Object.keys(cubeByTimeline).forEach((timeline) => {
      Ana2NameByTimeline[timeline] = _.groupBy(
        cubeByTimeline[timeline],
        'ana2Name'
      );
    });

    Object.keys(Ana2NameByTimeline).forEach((timeline) => {
      const ana2Timeline = Ana2NameByTimeline[timeline];
      Object.keys(ana2Timeline).forEach((ana2Name) => {
        if (!Ana3NameByTimeline.hasOwnProperty(timeline)) {
          Ana3NameByTimeline[timeline] = {};
        }

        Ana3NameByTimeline[timeline][ana2Name] = _.groupBy(
          ana2Timeline[ana2Name],
          'ana3Name'
        );

        const ana3Timeline = Ana3NameByTimeline[timeline][ana2Name];
        Object.keys(ana3Timeline).forEach((ana3Name) => {
          Ana3NameByTimeline[timeline][ana2Name][ana3Name] = ana3Timeline[
            ana3Name
          ]
            .map((d) => d.flux)
            .reduce((a, b) => a + b, 0);
        });

        Ana2NameByTimeline[timeline][ana2Name] = ana2Timeline[ana2Name]
          .map((d) => d.flux)
          .reduce((a, b) => a + b, 0);
      });
    });

    return {
      ana2: Ana2NameByTimeline,
      ana3: Ana3NameByTimeline,
      ana3ListByAna2
    };
  }
);

export const selectAnaPL = createSelector(
  selectAnalyticsEntities,
  selectFlatAna2Groups,
  selectAnaByTimeline,
  (anaMap, ana2Groups, { ana2, ana3, ana3ListByAna2 }) => {
    ana2Groups = ana2Groups.map((ana2Group) => {
      const groupKey = ana2Group.path.split('#')[0];
      ana2Group.groupName = anaMap['group#' + groupKey].name;
      return ana2Group;
    });
    const groups = _.groupBy(ana2Groups, 'groupName');

    Object.keys(groups).forEach((groupName) => {
      groups[groupName] = groups[groupName].map((g) => g.name);
    });

    return { groups, ana2, ana3, ana3ListByAna2 };
  }
);
